import { Suspense } from 'react';
import { FeaturedArticles, FeaturedArticlesSkeleton } from '../FeaturedArticles';
import { MagazineSearch } from '../MagazineSearch/MagazineSearch';

type MagazineAsideProps = {
  defaultQuery?: string;
};

function MagazineAside({ defaultQuery }: MagazineAsideProps) {
  return (
    <aside className="flex min-w-0 flex-col gap-8" data-testid="magazine-aside">
      <MagazineSearch defaultQuery={defaultQuery} />
      <Suspense fallback={<FeaturedArticlesSkeleton />}>
        <FeaturedArticles />
      </Suspense>
    </aside>
  );
}

export { MagazineAside, type MagazineAsideProps };
